<template>
    <div class="layout-right"ref="layout-right">
        <div class="layout-right-top">
            <right-top bread="系统设置-提成方案设置"></right-top>
        </div>
        <div class="layout-right-body">
            <el-form ref="form" :model="form" label-width="120px">
                <el-form-item label="提成方案名称" prop="name" :rules="[{required: true, message: '方案名称必须填写'}]">
                    <el-input v-model="form.name" style="width: 250px" :disabled="!isMain && isUnified" />
                    <div class="tips">可针对不同级别或组别的员工设置不同的提成方案</div>
                </el-form-item>
                <el-form-item label="适配员工" prop="staff_list" :rules="[{required: true, message: '必须选择适配的员工'}]">
                    <div class="select-staff-box flex">
                        <div class="button-box">
                            <el-button plain size="small" @click="selectStaffState = true">选择适配员工</el-button>
                        </div>
                        <div class="flex-1 staff-desc">
                            <el-tag
                                    class="staff-node"
                                    v-for="(val, k) in form.staff_list"
                                    :key="k"
                                    closable
                                    type="warning"
                                    size="small"
                                    @close="deleteSelectStaff(k)"
                                    effect="plain">
                                {{val.work_id}} {{ val.name }}
                            </el-tag>
                        </div>
                    </div>
                </el-form-item>
                <div class="rule-body">
                    <div class="label">提成规则设置: </div>
                    <div class="body">
                        <staff-reward-option-body-rule :disabled="!isMain && isUnified" :pro-type="parseInt(proType)" :rule-data="form.rule_data" @change="ruleChange" />
                    </div>
                </div>
                <div class="form-foot">
                    <el-row>
                        <el-col :span="24">
                            <div class="sub-line">
                                <el-button type="primary" @click="onSubmit">提交</el-button>&nbsp;&nbsp;&nbsp;&nbsp;
                                <el-button @click="onClose">取消</el-button>
                            </div>
                        </el-col>
                    </el-row>
                </div>
            </el-form>
        </div>

        <!--选择适配员工-->
        <staff-reward-option-staff-select v-model="selectStaffState" :selected-staff="form.staff_list" @selected="staffSelected"
            :rew-id="id" :pro-type="parseInt(proType)"
        />
    </div>
</template>

<script>
    import RightTop from "@/model/RightTop";
    import obj from "@/js/obj";
    import StaffRewardOptionBodyRule from "@/model/Option/StaffRewardOptionBodyRule";
    import StaffRewardOptionStaffSelect from "@/model/Option/StaffRewardOptionStaffSelect";
    export default {
        name: "StaffRewardOption",
        components: {StaffRewardOptionStaffSelect, StaffRewardOptionBodyRule, RightTop},
        props: {
            id: {
                type: [Number, String],
                default: null
            },
            proType: {
                type: [Number, String],
                default: 1
            }
        },
        data: () => ({
            activeName: "ProductOption",
            type: {
                product: 1,
                goods: 2,
                card: 5
            },

            selectStaffState: false,
            form: {
                name: "",
                staff_list: [
                    // {
                    //     id: 1,
                    //     username: "理发师8号 欧阳张三"
                    // }
                ],
                rule_data: [
                    // {
                    //
                    // }
                ]
            }
        }),
        computed: {
            isMain(){
                return this.$store.state.chain_option.is_main;
            },
            isUnified(){
                return this.$store.state.chain_option.is_unified_manage;
            }
        },
        mounted: function () {
            this.$store.commit("setMenuId", "7-2");
            this.loadOptionInfo();
        },
        methods: {
            //加载配置
            loadOptionInfo: function () {
                let postData = {
                    pro_type: this.proType,
                    id: this.id
                };
                obj.postData("store_reward/get_reward_option", postData, res => {
                    if(res.errcode === 0) {
                        this.form = res.data;
                    }else{
                        obj.message.error(res.errdesc);
                    }
                });
            },
            //选择适配员工回调
            staffSelected: function (staffArr) {
                this.form.staff_list = staffArr;
            },
            //删除选择员工
            deleteSelectStaff: function (index) {
                this.form.staff_list.splice(index, 1);
            },
            //规则改变
            ruleChange: function (newData) {
                this.form.rule_data = newData;
            },
            //关闭
            onClose: function () {
                this.$router.go(-1);
            },
            //提交保存
            onSubmit: function () {
                this.$refs['form'].validate(valid => {
                    if(!valid) return false;

                    let postData = {
                        id: this.id ? this.id : 0,
                        pro_type: this.proType ? this.proType : 0,
                        name: this.form.name ? this.form.name : "",
                        staff_list: this.form.staff_list ? JSON.stringify(this.form.staff_list) : "",
                        rule_data: this.form.rule_data ? JSON.stringify(this.form.rule_data) : "",
                    };
                    obj.postData("store_reward/save_reward_option", postData, res => {
                        if(res.errcode === 0) {
                            obj.message.success("保存成功");
                            this.onClose();
                        } else {
                            obj.message.error(res.errdesc);
                        }
                    });
                });
            }
        },
        watch: {

        }
    }
</script>

<style scoped>
    .layout-right-body{
        margin: 16px;
        background-color: #FFFFFF;
    }
    .tips{
        color: #999;
    }
    .rule-body>.label{
        color: #666;
        background-color: #f7f8fa;
        line-height: 50px;
        font-size: 16px;
    }
    .rule-body>.label::before{
        content: " ";
        display: inline-block;
        vertical-align: text-top;
        width: 4px;
        height: 15px;
        background-color: #0f9cf3;
        border-radius: 2px;
        margin-right: 6px;
        margin-left: 5px;
    }
    .rule-body>.body{
        margin-top: 10px;
        margin-bottom: 10px;
    }
    .select-staff-box .staff-desc{
        padding-left: 10px;
        color: #666666;
    }
    .select-staff-box .staff-node{
        margin-right: 5px;
    }
    .form-foot{
        padding-bottom: 26px;
        text-align: center;
    }
</style>

